import { useMemo } from 'react'
import useSWR from 'swr'
import { usePid2, isSelectedPid } from '@/components/DropdownPid'
import { useCountry, isSelectedCountry } from '@/components/DropdownCountry'
import { usePackageName, isSelectedPackageName } from '@/components/DropdownPackage'

export const useNoteDates = (startDate, endDate) => {
  const pids = usePid2((state) => state.pids)
  const country = useCountry((state) => state.value)
  const packageName = usePackageName((state) => state.value)
  const validRange = Boolean(startDate && endDate && Number(startDate) <= Number(endDate))
  const query = {
    startDate: Math.max(Number(startDate), 20250208),
    endDate,
    pid: pids.length === 1 && /^\d+$/.test(String(pids[0])) ? pids[0] : undefined,
    country: country && country !== 'total' ? country : undefined,
    packageName: packageName && packageName !== 'total' ? packageName : undefined,
  }
  const modern = useSWR(
    validRange && Number(endDate) >= 20250208 ? ['/troas/notes/dates', query] : null,
  )
  // Historical notes already support range queries; do not request them per row.
  const legacy = useSWR(
    validRange && Number(startDate) < 20250208
      ? ['/notes', { startDate, endDate: Math.min(Number(endDate), 20250207) }]
      : null,
  )
  const dates = useMemo(() => {
    const rows = [...(modern.data?.data?.dates ?? []), ...(legacy.data ?? [])]
    return new Set(rows.filter((note) =>
      isSelectedPid(note.pid, pids) &&
      isSelectedCountry(note.country, country) &&
      isSelectedPackageName(note.packageName, packageName),
    ).map((note) => String(note.date)))
  }, [modern.data, legacy.data, pids, country, packageName])

  return {
    dates,
    isLoading: modern.isLoading || legacy.isLoading,
    error: modern.error || legacy.error,
    ledgerAvailable: modern.data?.data?.ledgerAvailable !== false,
  }
}
